'use client';

import type { ReactNode } from 'react';
import { I18nProvider } from 'react-aria-components';

interface AriaLocaleProviderProps {
  locale: string;
  children: ReactNode;
}

export function AriaLocaleProvider({ locale, children }: AriaLocaleProviderProps) {
  return <I18nProvider locale={locale}>{children}</I18nProvider>;
}
